// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsCompensation = exports;

export const CompensationInhabitant = 'Compensation';

export type Compensation = typeof CompensationInhabitant;

export function isCompensation(v: any): v is Compensation {
  return CompensationInhabitant == v;
}

export type CompensationSingleton = Compensation;
